import { NUMEROLOGY_TOPIC_SEARCH_INDEX } from 'schools/numerology/data/numerologySearchIndex';

const LAST_TOPIC_STORAGE_KEY = 'richuals.numerology.lastTopicId';

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/** @param {number} count @param {string[]} [excludeIds] */
export function pickRandomNumerologyTopics(count = 2, excludeIds = []) {
  const exclude = new Set(excludeIds);
  const pool = NUMEROLOGY_TOPIC_SEARCH_INDEX.filter((e) => e.id && !exclude.has(e.id));
  if (pool.length <= count) return shuffle(pool);
  return shuffle(pool).slice(0, count);
}

/** @param {string | null} topicId */
export function saveLastNumerologyTopic(topicId) {
  if (!topicId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LAST_TOPIC_STORAGE_KEY, topicId);
  } catch {
    /* quota / private mode */
  }
}

/** @returns {string | null} */
export function readLastNumerologyTopic() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(LAST_TOPIC_STORAGE_KEY);
  } catch {
    return null;
  }
}
